import manusingcomputer from './Man-Using-Computer.png'
import sideimage from './sideimage.png'
import Rect1 from './Rect1.png'
import CottonCorp from './Cotton_corp_add.png'
import India from './India.png'
import Contact from './Contact.png'
import profile_tools from './profile_tools.png'
import profile_tools1 from './profile_tools_1.png'
import Live from './Live.png'
import logo from './logo copy.png'
import barely from './bareliy.jpg'
import reciept_header from './Receipt-Header.png'
import footer_with_signatory_line from './Footer-with-Signatory-Line.png'
import login_side_img from './Login-Side-img.png'
import dashboard_img from './Dashboard-img.png'
import barely_black_bg_img from './Bareliy_Black_bg-img.png'
import Applied_Ministry from './Applied_Ministry.jpg'
import dashboard_bg_1 from './1.png'
import active_tenders from './Active-Tenders.png'
import DeactiveTenders from './Deactive-Tenders.png'
import Footer_img from './Footer.png'
import whatsapp from './WhatsApp.png'
import email from './Email.png'
import img1 from '../AboutUsImages/img1.png'
import img2 from '../AboutUsImages/img2.png'
import user1 from '../AboutUsImages/User1.png'
import user2 from '../AboutUsImages/User2.png'
import user3 from '../AboutUsImages/User3.png'
import aboutusbg from '../AboutUsImages/About-us-bg-img.png'
import ourteam from '../AboutUsImages/Our-Team.png'
import contactusbg from '../ContactUsImages/Contact-us-bg-img.png'
import location from '../ContactUsImages/Location.png'
import contact from '../ContactUsImages/Contact.png'
import email1 from '../ContactUsImages/Email.png'
import mayor1 from '../AboutUsImages/mayor-bareilly.jpg'
import mayor2 from '../AboutUsImages/municapal-bareilly.jpg'
import logout from '../LoginImages/Logout.png'
import Graph64 from './Graph-64.png'
import MoreMenu64 from './More-Menu-64.png'
import NewTasks64 from './New-Tasks-64.png'
import Spendthismonth64 from './Spendthismonth64.png'
import TotalProjects64 from './Total-Projects-64.png'
import Approved32 from './Approved-32.png'
import Disable32 from './Disable32.png'
import Error32 from './Error32.png'
import Click32 from './Click-32.png'
import Unclick32 from './Unclick-32.png'
import YourBalance from './Your-Balance.png'
import Sales from './Sales.png'
import Earnings from './Earnings.png'
import Earningss from './Earningss.png'
import Earningsss from './Earningsss.png'
import first from './11.png'
import Second from './2.png'
import third from './3.png'
import forth from './4.png'
import fifth from './5.png'
import Vadhavan from './Vadhavan.png'
import VadhavanLogin from './VadhavanLogin.png'
import submit from './submit.png'
import Cancel32 from './Cancel32.png'
import DeleteWhite32 from './Delete-White32.png'
import DeleteRed32 from './Delete-Red32.png'
import EditBlueBlue32 from './Edit-Blue-Blue32.png'
import EditWhite32 from './Edit-White32.png'
import Tax32 from './Tax32.png'
import UpdateWhite32 from './Update-White32.png'
import PhoneNumber32 from './Phone-Number32.png'
import Email32 from './Email32.png'
import video from './video.mp4'
import Adminimg from './AdminLogin.png'
import AdminLogo from './AdminLogo.png'
import AdminWhite from './AdminWhite.png'
import VadhvanLogo256 from './Vadhvan-Logo256.png'
import Profile from './Profile.png'
import True32 from './True32.png'
import navimg from './nav.png'
import BillApprovals32 from './Bill-Approvals32.png'
import Dashboard32 from './Dashboard32.png'
import EmployeeManagement32 from './Employee-Management32.png'
import MISReports32 from './MIS-Reports32.png'
import Master32 from './Budget-Master-32.png'
import Report32 from './Report32.png'
import VendorManagement32 from './Vendor-Management 32.png'
import CreateDepartment32 from './Create-Department32.png'
import CreateEmployee32 from './Create-Employee32.png'
import CreateRole32 from './Create-Role32.png'
import EditViewEmp from './Edit,-View-Emp32.png'
import EditRoles32 from './Edit-Roles32.png'
import Rate from './Rate.png'
import UploadBill32 from './Upload-Bill32.png'
import Location32 from './Location32.png'
import Bank32 from './Bank-32.png'
import ECSFile from './ECSFile.png'
import BankofMaharashtraLogo256 from './Bank-of-Maharashtra-Logo256.png'
import ProjectDashboard from './Project-Dashboard-32.png'
import DemandGeneration from './Demand-Generation-32.png'
import TotalAmountRelease from './Total-Amount-Release.png'
import TotalDeductionAmount from './Total-Deduction-Amount.png'
import TotalDemandGenerations from './Total-Demand-Generations.png'
import TotalWorkOrders from './Total-Work-Orders.png'
import TotalEsitmateAmount from './Total-Esitmate-Amount.png'
import TotalHeadsAssigns from './Total-Heads-Assigns.png'
import TotalProjectCost from './Total-Project-Cost.png'
import EditIcon from './Edit-32.png'
import DeleteIcon from './Delete-32.png'
import Delete32WHITE from './Delete-32-WHITE.png'
import Edit32WHITE from './Edit-32_WHITE.png'
import VendorName32 from './Vendor-Name-32.png'
import AddFile32 from './Add-File-32.png'
import AddDeduction32 from './Add-Deduction-32.png'
import DemandGenerationblue from './Demand-Generation-32_blue.png'
import Excel32 from './Excel-32.png'
import JPG32 from './JPG-32.png'
import PNG32 from './PNG-32.png'
import Time32 from './Time-32.png'
import FileSendToBank32 from './File-Send-To-Bank-32.png'
import DemandGeneratedSuccessfully32 from './Demand-Generated-Successfully-32.png'
import BillApproved32 from './Bill-Approved-32.png'
import PDF32 from './PDF-32.png'
import CSV32 from './CSV-32.png'
import BudgetEstimation32 from './Budget-Estimation32.png'
import BudgetHeadManagement32 from './Budget-Head-Management-32.png'
import ProjectManagement32 from './Project-Management-32.png'
import ReleaseFromFinance32 from './Release-From-Finance-32.png'
import BudgetHeadCreationBlue32 from './Budget-Head-Creation-Blue-32.png'
import ProjectCreation64 from './Project-Creation-32.png'
import ApprovePay32 from './Approve-&-Pay-32.png'
import SendBack32 from './Send-Back-32.png'
import Add32 from './Add 32.png'

export {SendBack32,ApprovePay32,ProjectCreation64,BudgetHeadCreationBlue32,ReleaseFromFinance32,ProjectManagement32,BudgetHeadManagement32,BudgetEstimation32,CSV32,PDF32,img1, img2, user1, user2, user3, aboutusbg, ourteam, contactusbg, location, contact, email1, whatsapp, email, Footer_img, DeactiveTenders, active_tenders, dashboard_bg_1, barely_black_bg_img, Applied_Ministry, dashboard_img, login_side_img, footer_with_signatory_line, reciept_header, barely, logo, Live, manusingcomputer, sideimage, Rect1, CottonCorp, India, Contact, profile_tools, profile_tools1, mayor1, mayor2, logout, Graph64, MoreMenu64, NewTasks64, TotalProjects64, Spendthismonth64, Approved32, Disable32, Error32, Click32, Unclick32, YourBalance, Sales, Earnings, Earningss, Earningsss, first, Second, third, forth, fifth, Vadhavan, VadhavanLogin, submit, Cancel32, Tax32, DeleteWhite32, DeleteRed32, EditWhite32, EditBlueBlue32, UpdateWhite32, PhoneNumber32, Email32, video, Adminimg, AdminLogo, AdminWhite, VadhvanLogo256, Profile, True32, navimg, BillApprovals32, Dashboard32, EmployeeManagement32, MISReports32, Master32, Report32, VendorManagement32, CreateDepartment32, CreateEmployee32, CreateRole32, EditViewEmp, EditRoles32, Rate, UploadBill32, Location32, Bank32, ECSFile, BankofMaharashtraLogo256, ProjectDashboard, DemandGeneration, TotalAmountRelease, TotalDeductionAmount, TotalDemandGenerations, TotalWorkOrders, TotalEsitmateAmount, TotalHeadsAssigns, TotalProjectCost, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE, VendorName32, AddFile32, AddDeduction32, DemandGenerationblue, PNG32, JPG32, Excel32 ,Time32,BillApproved32,DemandGeneratedSuccessfully32,FileSendToBank32,Add32}